import React from 'react';
import TablaVerificarPagos from '../components/ingresos/tablaVerificarPagos';

function Verificacion() {
  return (
      <div className='col-12 d-flex justify-content-center row'>
        <TablaVerificarPagos />
      </div>
  );
}

export default Verificacion;




// WEBPACK FOOTER //
// ./src/pages/verificacion.js